

module.exports = __webpack_require__.stylable.create(
    "Spinner1445494544",
    {"classes":{"root":"Spinner1445494544__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    14,
    "Spinner1445494544",
    null
);
